import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const MapsApi = createApi({
  reducerPath: "MapsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: 'http://5.195.10.167:1400/nom/reverse.php',
  }),
  tagTypes: ["Maps"],
  endpoints: (builder) => ({
    getLocationFromAddress: builder.query<any, any>({
      query: (address) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `address=${address}`,
        method: "GET",
      }),
    }),
    getAddressFromLocation: builder.query<any, any>({
      query: (_payload_) => ({
        headers: {
          "Content-type": "application/json",
        },
        url: `?format=json&lat=${_payload_.location.lat}&lon=${_payload_.location.lng}&accept-language=en`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetLocationFromAddressQuery, useGetAddressFromLocationQuery } = MapsApi;
